// @flow

import type { AlertsState } from "./types";

export const initialState: AlertsState = {
  requestsInProgress: 0,
  list: null,
};

export default initialState;
